export const SCROLL_CAROUSEL_DEFAULTS = {
    scrollCarouselLog: '',
    scrollCarouselIndex: 1,
    isScrollCarouselForSongSelect: false,
}
